// サブスク購入枠調整
const subscriptions = document.querySelectorAll(".shopify_subscriptions_app_block");
console.log(subscriptions);

if (subscriptions.length > 0) {
  const prices = document.querySelectorAll(".shopify_subscriptions_in_widget_price");
  const policyTexts = document.querySelectorAll(".shopify_subscriptions_app_policy");

  // pricesの最後のテキストのJPYの文字を削除
  if (prices.length > 0) {
    prices.forEach(price => {
      price.innerHTML = price.innerHTML.replace(" JPY", "");
    });
  };

  // policyTextのDOMの位置を兄弟要素のdiv内の最後の.shopify_subscriptions_app_block_labelの中に移動
  if (policyTexts.length > 0) {
    policyTexts.forEach((policyText) => {
      const parentElm = policyText.closest("fieldset");
      if (parentElm) {
        const labels = parentElm.querySelectorAll(".shopify_subscriptions_app_block_label");
        labels.forEach((label) => {
          label.appendChild(policyText);
        });
      }
    });
  };
}